import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const FiltrosDashboard = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const sucursalesListado = useSelector(state => state.sucursales.listado);
    const eventosListado    = useSelector(state => state.eventos.listado);

    const [sucursalData, setSucursalData] = useState(null);
    const [eventoData,   setEventoData]   = useState(null);
    const [fechaInicio,  setFechaInicio]  = useState(null);
    const [fechaFin,     setFechaFin]     = useState(null);

    useEffect(() => {
        if (show) {
            setFechaInicio(filtros.fecha_inicio ? new Date(filtros.fecha_inicio) : null);
            setFechaFin(filtros.fecha_fin ? new Date(filtros.fecha_fin) : null);

            const sucOpc = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
            setSucursalData(filtros.sucursal ? sucOpc.find(s => s.value === filtros.sucursal) ?? null : null);

            const evOpc = eventosListado.map(e => ({ value: e._id, label: e.nombre }));
            setEventoData(filtros.evento ? evOpc.find(e => e.value === filtros.evento) ?? null : null);
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            sucursal:    sucursalData ? sucursalData.value : null,
            evento:      eventoData   ? eventoData.value   : null,
            fecha_inicio: fechaInicio ? new Date(new Date(fechaInicio).setHours(0, 0, 0, 0))    : null,
            fecha_fin:    fechaFin    ? new Date(new Date(fechaFin).setHours(23, 59, 59, 999))  : null
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        const hoy = new Date();
        const inicio = new Date(new Date(hoy).setHours(0, 0, 0, 0));
        const fin    = new Date(new Date(hoy).setHours(23, 59, 59, 999));
        setSucursalData(null);
        setEventoData(null);
        setFechaInicio(inicio);
        setFechaFin(fin);
        handleAplicar({ sucursal: null, evento: null, fecha_inicio: inicio, fecha_fin: fin });
        handleCerrar();
    };

    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
    const eventosOpciones    = eventosListado.map(e => ({ value: e._id, label: e.nombre }));

    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Sucursal"
                                options={sucursalesOpciones}
                                value={sucursalData}
                                onChange={option => setSucursalData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Evento"
                                options={eventosOpciones}
                                value={eventoData}
                                onChange={option => setEventoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_inicio"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaInicio}
                                    onChange={date => setFechaInicio(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_inicio">Fecha inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_fin"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaFin}
                                    onChange={date => setFechaFin(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                    minDate={fechaInicio}
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_fin">Fecha fin</label>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosDashboard;
